import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const FieldCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FieldError = styled.p`
  color: ${tokens.status.danger.fg};
  font-size: ${tokens.font.label};
  line-height: 1rem;
  margin-top: 0.25rem;
`

export const MockEngineNote = styled.p`
  color: ${tokens.text.muted};
  font-size: ${tokens.font.label};
  line-height: 1rem;
  white-space: nowrap;
`
